import { NavLink } from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function ContactForm(props) {
    return (
      <>
         <section id="header" className="d-flex align-items-center">
         <div className="container-fluid">
      <div className="row">
        <div className="col-10 mx-auto">
          <div className='row'>
            <div className="col-md-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex justify-content-center flex-column">
              <h2>{props.tagLine} <strong className="brand-name"> Muhammad Anas</strong></h2>
              <h3 className="my-3">
                Email: <span style={{color:'#0071f2'}}>joshepmethew98@gmail.com</span>
              </h3>
              <h3 className="my-3">
                Phone & Whatsapp: <span style={{color:'#0071f2'}}>03091514823</span>
              </h3>
              <a href="https://www.linkedin.com/in/anas4211/" target='_blank'><strong className="brand-name"> Muhammad Anas</strong><i className="fa-brands fa-linkedin fa-2x ml-2"></i></a>
              <div className="mt-3">
                <NavLink to={props.visit}><button className="btn-gs">{props.btnName}</button></NavLink>
              </div>
            </div>    
            <div className="col-lg-6 order-1 order-lg-2 header-img">
                <div className='img-div'> 
                <img src={props.imgSrc} className="img-fluid animated mt-4 home_img"  alt="Home img"/>
                </div>
            </div>
            </div>
        </div>
      </div>
    </div>
         </section>
      </>
    );
  }
  
  export default ContactForm;
  